import React, { useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  remove_session,
  getAdditionalWorkouts,
  updateAdditionalWorkout,
  addAdditionalWorkout,
  deleteAdditionalWorkoutPermanently,
  restoreAdditionalWorkout,
  deleteAdditionalWorkout,
  sortAdditionalWorkouts,
} from "../../../../functions/general";
import { toast } from "react-toastify";
import Media from "../../../../components/Media";
import ModalImage from "react-modal-image";
import { usePermissions } from "../../../../functions/usePermissions";

import { SortableContainer, SortableElement, SortableHandle, arrayMove } from "react-sortable-hoc";

function ListWorkouts(props) {
  const navigate = useNavigate();
  const { hasPermission } = usePermissions();

  const [additionalWorkouts, setAdditionalWorkouts] = React.useState([]);
  const [modalTitle, setModalTitle] = React.useState("");
  const [modalButtonText, setModalButtonText] = React.useState("");
  const [title, setTitle] = React.useState("");
  const [image, setImage] = React.useState("");
  const [description, setDescription] = React.useState("");
  const [id, setId] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const [errors, setErrors] = React.useState("");
  const [isPaid, setIsPaid] = React.useState(true);
  const [tableDataLoading, setTableDataLoading] = React.useState(true);

  const { state } = useLocation();

  useEffect(() => {
    props.setPageTitleAndSubTitle(state?.subcategory?.title, `Here is the list of ${state?.subcategory?.title} workouts !`);
    fetchData();
  }, []);

  const fetchData = (type) => {
    getAdditionalWorkouts(state?.subcategory?._id).then((res) => {
      if (res && (res.status == 200 || res.status == 201)) {
        setAdditionalWorkouts(res?.data?.workouts);
        if (type === "add") {
          let sortedArray = [];
          res?.data?.map((workout) => sortedArray.push(workout?._id));
          sortAdditionalWorkouts(sortedArray).then((res) => {
            if (res && res.status == 200) {
              // fetchData();
            } else if (res && res.status == 401) {
              remove_session();
              props.getLoggedInUser();
              navigate("/login");
            } else {
              toast.error("Failed to sort the list.");
            }
            setTableDataLoading(false);
          });
        }
      } else if (res && res.status == 401) {
        remove_session();
        props.getLoggedInUser();
        navigate("/login");
      } else {
      }
      setTableDataLoading(false);
    });
  };

  const modalHandler = (workout) => {
    if (workout && workout._id) {
      setModalTitle("Update Additional Workout");
      setModalButtonText("Update");
      setTitle(workout.title);
      setImage(workout.image);
      setDescription(workout.text);
      setIsPaid(workout?.isPaid);
      setId(workout._id);
    } else {
      setModalTitle("Add New Additional Workout");
      setModalButtonText("Add");
      setTitle("");
      setImage("");
      setDescription("");
      setIsPaid(true);
      setId("");
    }
  };

  const onSubmit = (e) => {
    e.preventDefault();
    if (loading) return false;
    if (validate()) {
      setLoading(true);
      const workoutData = {
        title: title,
        image: image,
        text: description ? description : "",
        subcategory: state?.subcategory,
        isPaid: isPaid,
      };
      let type = "add";
      if (id) {
        updateAdditionalWorkout(id, workoutData).then((res) => {
          if (res && res.status == 200) {
            fetchData();
            toast.success("Workout updated successfully.");
            document.getElementById("categoryModalCloseButton").click();
          } else if (res && res.status == 401) {
            remove_session();
            props.getLoggedInUser();
            navigate("/login");
          } else {
            toast.error("Failed to update Workout.");
          }
          setLoading(false);
        });
      } else {
        addAdditionalWorkout(workoutData).then((res) => {
          if (res && res.status == 201) {
            fetchData(type);
            toast.success("Workout added successfully.");
            document.getElementById("categoryModalCloseButton").click();
          } else if (res && res.status == 401) {
            remove_session();
            props.getLoggedInUser();
            navigate("/login");
          } else {
            toast.error("Failed to add Workout.");
          }
          setLoading(false);
        });
      }
    }
  };

  const validate = () => {
    let errors = {
      title: "",
      image: "",
      // description: "",
    };
    let isValid = true;
    if (!title) {
      isValid = false;
      errors.title = "Please enter title.";
    }
    if (!image) {
      isValid = false;
      errors.image = "Please select an image";
    }
    // if (!description) {
    //   isValid = false;
    //   errors.description = "Please enter description";
    // }
    setErrors(errors);
    return isValid;
  };

  const deleteHandler = (e, subcategory) => {
    e.preventDefault();
    if (window.confirm("Are you sure you want to delete workout?") == true) {
      if (window.confirm("Are you sure you want to delete workout permanently?") == true) {
        deleteAdditionalWorkoutPermanently(subcategory._id).then((res) => {
          if (res && res.status == 200) {
            fetchData();
            toast.success("Workout deleted successfully.");
          } else if (res && res.status == 401) {
            remove_session();
            props.getLoggedInUser();
            navigate("/login");
          } else {
            toast.error("Failed to delete subcategory.");
          }
        });
      }
    }
  };

  const deleteStatusHandler = (e, subcategory) => {
    e.preventDefault();
    let confirmText = "Are you sure you want to in-active the workout?";
    if (subcategory.isDeleted) {
      confirmText = "Are you sure you want to active the workout?";
    }
    if (window.confirm(confirmText) == true) {
      if (subcategory.isDeleted) {
        restoreAdditionalWorkout(subcategory._id).then((res) => {
          if (res && res.status == 200) {
            fetchData();
            toast.success("Workout activated successfully.");
          } else if (res && res.status == 401) {
            remove_session();
            props.getLoggedInUser();
            navigate("/login");
          } else {
            toast.error("Failed to active workout.");
          }
        });
      } else {
        deleteAdditionalWorkout(subcategory._id).then((res) => {
          if (res && res.status == 200) {
            fetchData();
            toast.success("Workout deactivated successfully.");
          } else if (res && res.status == 401) {
            remove_session();
            props.getLoggedInUser();
            navigate("/login");
          } else {
            toast.error("Failed to inactive workout.");
          }
        });
      }
    }
  };

  const paymentStatusHandler = (e, workout) => {
    e.preventDefault();
    let confirmText = "Are you sure you want to change payment status of workout?";
    if (window.confirm(confirmText) == true) {
      const workoutData = {
        title: workout?.title,
        image: workout?.image,
        text: workout?.text,
        subcategory: state?.subcategory,
        isPaid: e.target.checked,
      };
      updateAdditionalWorkout(workout._id, workoutData).then((res) => {
        if (res && res.status == 200) {
          fetchData();
          toast.success("Payment status changed successfully.");
        } else if (res && res.status == 401) {
          remove_session();
          props.getLoggedInUser();
          navigate("/login");
        } else {
          toast.error("Failed to change the payment status of workout.");
        }
      });
    }
  };

  const setImageHandler = (image) => {
    setImage(image);
  };

  const onSortEnd = ({ oldIndex, newIndex }) => {
    setTableDataLoading(true);
    const updatedWorkouts = arrayMove(additionalWorkouts, oldIndex, newIndex);
    let sortedArray = [];
    updatedWorkouts?.map((workout) => sortedArray.push(workout?._id));
    sortAdditionalWorkouts(sortedArray).then((res) => {
      if (res && res.status == 200) {
        setAdditionalWorkouts(updatedWorkouts);
        // fetchData();
      } else if (res && res.status == 401) {
        remove_session();
        props.getLoggedInUser();
        navigate("/login");
      } else {
        toast.error("Failed to sort the list.");
      }
      setTableDataLoading(false);
    });
  };

  const DragHandle = SortableHandle(() => (
    <div
      style={{
        cursor: "move",
        width: "20px",
        height: "20px",
      }}
    >
      <svg
        aria-hidden="true"
        focusable="false"
        data-prefix="fas"
        data-icon="grip-vertical"
        role="img"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 320 512"
      >
        <path
          fill="#6e6e6e"
          d="M96 32H32C14.33 32 0 46.33 0 64v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32zm0 160H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm0 160H32c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zM288 32h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32V64c0-17.67-14.33-32-32-32zm0 160h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32zm0 160h-64c-17.67 0-32 14.33-32 32v64c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-64c0-17.67-14.33-32-32-32z"
        ></path>
      </svg>
    </div>
  ));

  const SortableTableRow = SortableElement(({ workout, serialNo }) => {
    return (
      <tr>
        <td>{serialNo + 1}</td>
        <td>
          <div className="maxWidth70px">
            <ModalImage small={process.env.REACT_APP_MEDIAPATH + workout?.image} large={process.env.REACT_APP_MEDIAPATH + workout?.image} />
          </div>
        </td>
        <td>
          {hasPermission("view-workout-overview") || hasPermission("view-workout-warmups") || hasPermission("view-workout-exercises") ? (
            <Link
              style={{ color: "blue" }}
              to="/workout-details"
              state={{ workout, category: state?.category, subCategory: state?.subcategory?.title }}
            >
              {workout?.title}
            </Link>
          ) : (
            workout?.title
          )}
        </td>
        {hasPermission("edit-workout") && (
          <td>
            <label className="switch">
              <input type="checkbox" checked={workout?.isPaid} onClick={(e) => paymentStatusHandler(e, workout)} />
              <span className="slider round"></span>
            </label>
          </td>
        )}
        {hasPermission("edit-workout") && (
          <td>
            <label className="switch">
              <input type="checkbox" checked={!workout.isDeleted} onClick={(e) => deleteStatusHandler(e, workout)} />
              <span className="slider round"></span>
            </label>
          </td>
        )}
        {(hasPermission("edit-workout") || hasPermission("delete-workout")) && (
          <td>
            <div className="d-flex">
              {hasPermission("edit-workout") && (
                <button
                  data-toggle="modal"
                  data-target="#add"
                  onClick={(e) => modalHandler(workout)}
                  className="btn btn-primary shadow btn-sm sharp mr-1"
                >
                  <i className="fa fa-pencil"></i>
                </button>
              )}
              {hasPermission("delete-workout") && (
                <button onClick={(e) => deleteHandler(e, workout)} className="btn btn-danger shadow btn-sm sharp">
                  <i className="fa fa-trash"></i>
                </button>
              )}
            </div>
          </td>
        )}
        {hasPermission("edit-workout") && (
          <td>
            <DragHandle />
          </td>
        )}
      </tr>
    );
  });

  const SortableTable = SortableContainer(({ additionalWorkouts }) => {
    return (
      <table id="roles-table" className="display dataTable" style={{ minWidth: "845px" }}>
        <thead>
          <tr>
            <th>No</th>
            <th>Image</th>
            <th>Name</th>
            {hasPermission("edit-workout") && <th>Paid</th>}
            {hasPermission("edit-workout") && <th>Status</th>}
            {(hasPermission("edit-workout") || hasPermission("delete-workout")) && <th>Actions</th>}
            {hasPermission("edit-workout") && <th>Sort Order</th>}
          </tr>
        </thead>
        <tbody>
          {tableDataLoading ? (
            <tr>
              <td colSpan="7" className="text-center pt-5">
                <div className="spinner-border text-black" role="status" aria-hidden="true"></div>
              </td>
            </tr>
          ) : (
            <>
              {additionalWorkouts?.length > 0 ? (
                additionalWorkouts?.map((workout, index) => {
                  return <SortableTableRow key={index} workout={workout} index={index} serialNo={index} />;
                })
              ) : (
                <tr>
                  <td colSpan="7" className="text-center pt-5">
                    No workout found!
                  </td>
                </tr>
              )}
            </>
          )}
        </tbody>
      </table>
    );
  });

  return (
    <>
      <div className="container-fluid">
        <div className="row mb-4 align-items-center">
          <div className="col-8">
            <ol class="breadcrumb bg-transparent mb-0" style={{ fontSize: "18px" }}>
              <li class="breadcrumb-item">
                <span onClick={() => navigate("/")}>
                  <i className="fas fa fa-home" style={{ fontSize: "28px", cursor: "pointer" }}></i>
                </span>
              </li>
              <li class="breadcrumb-item">
                <span style={{ color: "#132C48", cursor: "pointer" }} onClick={() => navigate(-2)}>
                  Workout Categories
                </span>
              </li>
              <li class="breadcrumb-item">
                <span style={{ color: "#132C48", cursor: "pointer" }} onClick={() => navigate(-1)}>
                  {state?.category}
                </span>
              </li>
              <li class="breadcrumb-item active" aria-current="page">
                {state?.subcategory?.title}
              </li>
            </ol>
          </div>
          <div className="col-4">
            {hasPermission("add-workout") && (
              <button className="btn btn-primary float-right" data-toggle="modal" data-target="#add" onClick={(e) => modalHandler()}>
                Add New
              </button>
            )}
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-body">
                <div className="table-responsive">
                  {tableDataLoading ? (
                    <div className="text-center py-5">
                      <div className="spinner-border text-black" role="status" aria-hidden="true"></div>
                    </div>
                  ) : (
                    <>
                      <SortableTable additionalWorkouts={additionalWorkouts} onSortEnd={onSortEnd} useDragHandle={true} />
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="modal fade" id="add">
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header border-0 px-3 mb-3">
                <h5 className="modal-title">{modalTitle}</h5>
                <button type="button" className="close" data-dismiss="modal" id="categoryModalCloseButton">
                  <span>&times;</span>
                </button>
              </div>
              <form noValidate onSubmit={onSubmit}>
                <div className="form-group px-3">
                  <label>Title</label>
                  <input type="text" className="form-control" placeholder="Workout Title" value={title} onChange={(e) => setTitle(e.target.value)} />
                  {errors.title && !title && <div className="text-warning font-size-12 mt-2">{errors.title}</div>}
                </div>
                <div className="form-group px-3">
                  <label>Description</label>
                  <textarea
                    type="text"
                    className="form-control"
                    placeholder="Enter Description"
                    rows={4}
                    value={description}
                    onChange={(e) => setDescription(e.target.value)}
                  />
                  {/* {errors.description && !description && <div className="text-warning font-size-12">{errors.description}</div>} */}
                </div>
                <div className="form-group px-3">
                  <label>Image</label>
                  <br />
                  {image && (
                    <>
                      <img src={process.env.REACT_APP_MEDIAPATH + image} className="img-fluid img-thumbnail" width="150" />
                      <br />
                    </>
                  )}
                  <button type="button" className="btn btn-primary mt-3" data-toggle="modal" data-target="#media">
                    Select Image
                  </button>
                  {errors.title && !image && <div className="text-warning font-size-12 mt-2">{errors.image}</div>}
                </div>
                <div className="modal-footer border-0">
                  <button type="submit" className="btn btn-primary">
                    {loading && <span className="spinner-border spinner-border-sm mr-2" role="status" aria-hidden="true"></span>} {modalButtonText}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        <Media setImageHandler={setImageHandler} />
      </div>
    </>
  );
}

export default ListWorkouts;
